import { MapPin, Hotel, UtensilsCrossed, ExternalLink } from "lucide-react";
import loja from "../img/loja.png";
export default function GuiaLoja() {
  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="bg-white border border-slate-200 rounded-3xl overflow-hidden shadow-sm">
          <div className="grid lg:grid-cols-2">
            {/* Imagen */}
            <div className="relative h-80 lg:h-auto">
              <img
                src= {loja}
                alt="Ciudad de Loja"
                className="w-full h-full object-cover"
              />
              
            </div>

            {/* Contenido */}
            <div className="p-10 lg:p-14 flex flex-col justify-center">
              <span className="inline-flex w-fit items-center rounded-full bg-[#febe10]/20 px-4 py-1 text-sm font-semibold text-[#004270]">
                Guía del visitante
              </span>

              <h2 className="mt-5 text-4xl font-bold text-[#004270]">
                Descubre Loja
              </h2>

              <p className="mt-6 text-lg leading-8 text-slate-600">
                Haz de tu visita una experiencia inolvidable. Hemos preparado
                una guía con recomendaciones de lugares turísticos, hoteles,
                restaurantes y sitios de interés para que disfrutes al máximo tu
                estadía en la ciudad de Loja.
              </p>

              <div className="grid sm:grid-cols-3 gap-4 mt-8">
                <div className="flex items-center gap-3">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#004270]/10">
                    <MapPin className="text-[#004270]" size={22} />
                  </div>
                  <span className="text-sm font-medium text-slate-700">
                    Lugares turísticos
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#004270]/10">
                    <Hotel className="text-[#004270]" size={22} />
                  </div>
                  <span className="text-sm font-medium text-slate-700">
                    Hoteles recomendados
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#004270]/10">
                    <UtensilsCrossed className="text-[#004270]" size={22} />
                  </div>
                  <span className="text-sm font-medium text-slate-700">
                    Restaurantes
                  </span>
                </div>
              </div>

              <a
                href="https://eventos.utpl.edu.ec/sites/default/files/2026-08/loja.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-10 inline-flex w-fit items-center gap-2 rounded-xl bg-[#004270] px-7 py-4 text-white font-semibold transition-all duration-300 hover:bg-[#00345a] hover:shadow-lg"
              >
                Ver guía completa
                <ExternalLink size={18} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}